<template>
  <v-dialog v-model="dialog" fullscreen>
    <v-card>
      <v-toolbar dense color="primary" dark>
        <v-toolbar-title>
          {{
            category._id
              ? $t('titles.global.updateModel', {
                  field: $tc('models.category'),
                })
              : $t('titles.global.newAModel', { field: $tc('models.category') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-progress-linear
          :active="loading"
          height="3"
          :indeterminate="true"
          class="my-1"
        />
        <v-container py-0>
          <v-layout row wrap>
            <v-flex d-flex xs12 px-2>
              <translation-field
                ref="name"
                v-model="category.name"
                :label="$t('fields.global.name')"
              />
            </v-flex>

            <v-flex md3 xs12 px-2>
              <v-switch
                v-model="category.useThisForChangeSeason"
                :label="$t('titles.global.useThisForChangeSeason')"
                color="primary"
              />
            </v-flex>

            <v-flex md4 xs12 px-2>
              <v-text-field
                v-model="category.abbreviation"
                v-validate="
                  `${category.useThisForChangeSeason ? 'required' : ''}`
                "
                :label="`${
                  category.useThisForChangeSeason
                    ? `${$t('fields.global.abbreviation')} *`
                    : $t('fields.global.abbreviation')
                }`"
              />
            </v-flex>
            <v-flex md5 xs12 px-2>
              <!-- <v-autocomplete
              v-model="category.parentCategory"
              :items="categorySelectList.filter(item => item.value !== category._id)"
              :label="$t('action.actions.select', {field : $t('titles.categories.parentCategory') }) + ' (*)'"
              :loading="$store.state.categories.loading"
              :readonly="!!parentCategory"
              no-filter
              :search-input.sync="searchCategory"
            >
              <template v-slot:item="data">
                <v-list-tile-content>
                  <v-list-tile-title>-- -- -- {{data.item.text}}</v-list-tile-title>
                  <v-list-tile-sub-title
                    v-if="data.item.parent1"
                    class="body-1 grey--text text--lighten-1"
                  >-- -- {{ data.item.parent1 }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title
                    v-if="data.item.parent2"
                    class="body-1 grey--text text--lighten-1"
                  >-- {{ data.item.parent2 }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
              </v-autocomplete>-->
              <category-menu
                v-model="category.parentCategory"
                clearable
                :label="
                  $t('action.actions.select', {
                    field: $t('titles.categories.parentCategory'),
                  }) + ' (*)'
                "
                :loading="$store.state.categories.loading"
                :readonly="!!parentCategory"
              />
            </v-flex>
            <v-flex md3 xs12 px-2>
              <v-text-field
                v-model.number="category.order"
                v-validate="`numeric|min_value:1`"
                type="number"
                :label="$t('fields.global.order')"
                min="1"
                step="1"
                maxlength="2"
                :data-vv-name="$t('fields.global.order')"
                :error-messages="errors.collect($t('fields.global.order'))"
              />
            </v-flex>
            <v-flex md3 xs12 px-2>
              <v-text-field
                v-model.number="category.matchesDuration"
                v-validate="`min_value:1`"
                type="number"
                :label="$t('fields.tournaments.matchesDuration')"
                min="1"
                max="10"
                step="1"
                maxlength="2"
                :data-vv-name="$t('fields.tournaments.matchesDuration')"
                :error-messages="
                  errors.collect($t('fields.tournaments.matchesDuration'))
                "
              />
            </v-flex>
            <v-flex md6 xs12 px-2>
              <!-- <v-menu
                :close-on-content-click="false"
                :nudge-right="40"
                full-width
                lazy
                min-width="290px"
                offset-y
                ref="menu"
                transition="scale-transition"
                v-model="menuDate"
              >
                <v-text-field
                  v-model="startAt"
                  :label="$t('fields.tournaments.startAt')"
                  prepend-icon="event"
                  readonly
                  slot="activator"
                ></v-text-field>
                <v-date-picker
                  v-model="category.startAt"
                  @input="menuDate = false"
                  first-day-of-week="1"
                  :locale="$store.state.languages.iso()"
                ></v-date-picker>
              </v-menu>-->
              <date-picker
                v-model="category.startAt"
                :label="$t('fields.tournaments.startAt')"
              />
            </v-flex>
            <v-flex md4 xs12 px-2>
              <v-text-field
                v-model.number="category.ntimes"
                v-validate="`min_value:1`"
                type="number"
                :label="$t('fields.tournaments.ntimes')"
                min="1"
                max="10"
                step="1"
                maxlength="2"
                :data-vv-name="$t('fields.tournaments.ntimes')"
                :error-messages="
                  errors.collect($t('fields.tournaments.ntimes'))
                "
              />
            </v-flex>
            <v-flex md4 xs12 px-2>
              <v-text-field
                v-model.number="category.durationTime"
                v-validate="`min_value:1`"
                type="number"
                :label="$t('fields.tournaments.durationTime')"
                min="1"
                max="10"
                step="1"
                maxlength="2"
                :data-vv-name="$t('fields.tournaments.durationTime')"
                :error-messages="
                  errors.collect($t('fields.tournaments.durationTime'))
                "
              />
            </v-flex>
            <v-flex md4 xs12 px-2>
              <v-text-field
                v-model.number="category.durationBreak"
                v-validate="`min_value:1`"
                type="number"
                :label="$t('fields.tournaments.durationBreak')"
                min="1"
                max="10"
                step="1"
                maxlength="2"
                :data-vv-name="$t('fields.tournaments.durationBreak')"
                :error-messages="
                  errors.collect($t('fields.tournaments.durationBreak'))
                "
              />
            </v-flex>
            <v-flex md2 sm6 xs12 px-2>
              <v-switch
                v-model="category.active"
                :label="$t('fields.global.active')"
                color="primary"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
        <v-spacer />
        <v-btn small ripple color="primary" @click="updateCategory = true">
          {{ $t('action.buttons.updateInCascade') }}
        </v-btn>
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button
          v-if="!category._id"
          type="create"
          :loading="loading"
          @click="submit()"
        />
        <meta-button
          v-else
          type="update"
          :loading="loading"
          @click="submit()"
        />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
    <update-category
      :update-category="updateCategory"
      @close="updateCategory = false"
      @updateInCascade="updateInCascade"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import CategoryMenu from '@/components/management/categories/CategoryMenu'
import DatePicker from '@/components/widgets/Input/DatePicker'
import TranslationField from '@/components/widgets/Input/TranslationField'
import UpdateCategory from '@/components/widgets/dialog/UpdateCategoryByYear'
import { formatDatePicker } from '@/helpers/dateHelper'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'CategoryForm',
  components: {
    TranslationField,
    CategoryMenu,
    DatePicker,
    UpdateCategory,
  },
  props: {
    dialog: {
      default: false,
      required: true,
    },
    parentCategory: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      category: {},
      searchCategory: '',
      menuDate: false,
      date: '',
      updateCategory: false,
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
    parentCategory(val) {
      this.category.parentCategory = val
    },
    selected: {
      handler: function (val) {
        if (val) this.setObject(val)
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.setObject(this.selected)
  },
  computed: {
    ...mapState({
      selected: (state) => state.categories.selected,
      loading: (state) => state.categories.loading,
    }),
    ...mapGetters({
      categorySelectList: 'categories/selectList',
    }),
  },
  methods: {
    ...mapActions({
      setCreate: 'categories/create',
      setUpdate: 'categories/update',
      reset: 'categories/reset',
      setCategory: 'categories/updateCategory',
    }),
    submit() {
      Promise.all([this.validate(), this.$refs.name.validate()]).then(
        (valid) => {
          if (valid.some((valid) => !valid)) return
          let payload = Object.assign({}, this.category)
          if (!payload._id) {
            this.setCreate(payload).then((_) => {
              this.cancel()
            })
          } else {
            this.setUpdate(payload).then((_) => {
              this.cancel()
            })
          }
        }
      )
    },
    setObject(category) {
      this.category = parseObject({
        ...category,
        startAt: category.startAt || '',
      })
      this.category.name = category.name
      if (category._id)
        this.category.startAt = formatDatePicker(category.startAt)

      if (this.parentCategory) {
        this.category.parentCategory = this.parentCategory
      }
    },
    cancel() {
      this.$emit('close')
      this.clear()
    },
    clear() {
      this.nextTick((_) => {
        this.$emit('reset')
        this.reset()
        this.$validator.reset()
        if (this.$refs.name) this.$refs.name.$validator.reset()
      })
    },
    updateInCascade(value) {
      const data = {
        yearStart: value,
        category: this.category._id,
      }
      this.setCategory(data)
    },
  },
}
</script>
